import { z } from 'zod';
import { SystemRole } from '../types/index.js';
/**
 * A person may be added with no email — somebody the office reaches by phone.
 * They cannot sign in (sign-in is by email), so they need a phone instead.
 */
export const createUserSchema = z
    .object({
    email: z
        .string()
        .trim()
        .nullish()
        .transform((v) => (v ? v : null))
        .refine((v) => v === null || z.string().email().safeParse(v).success, {
        message: 'Enter a valid email',
    }),
    name: z.string().min(1).max(255),
    systemRole: z.nativeEnum(SystemRole),
    phone: z.string().max(50).optional(),
    address: z.string().max(500).optional(),
    googleId: z.string().optional(),
})
    .refine((d) => !!d.email || !!d.phone?.trim(), {
    message: 'Enter an email, or a phone for somebody without one',
    path: ['email'],
});
// Update fields are nullable: the edit panels send null to clear a field
export const updateUserSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    phone: z.string().max(50).nullable().optional(),
    address: z.string().max(500).nullable().optional(),
    systemRole: z.nativeEnum(SystemRole).optional(),
    isActive: z.boolean().optional(),
    /** true / false, or null to go back to the role's default. */
    dailyTaskEmail: z.boolean().nullable().optional(),
});
//# sourceMappingURL=user.js.map